import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { ThreadObject } from '@/types';

export function useGetPublishedThreads(matterId: string, subsetId: string) {
  const { fetchConfigGET } = useGetFetchConfig();

  const getPublishedThreads = async () => {
    if (!matterId || !subsetId) {
      return [];
    }

    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/threads/published`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching threads failed');
    }
    return response.json();
  };

  return useQuery<ThreadObject[]>([QueryEntity.PublishedThreads, { matterId, subsetId }], getPublishedThreads, {
    refetchOnWindowFocus: false,
  });
}
